import { purple } from "../config";
import React, { useState } from "react";

interface StyledLinkProps {
  href?: string;
  rel?: string;
  target?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  isOnlyText?: boolean;
  dark?: boolean;
}

const StyledLink: React.FC<StyledLinkProps> = ({
  children,
  href = undefined,
  style = undefined,
  isOnlyText = false,
  dark = false,
  rel = "noopener noreferrer",
  target = "_blank",
}) => {
  const [hover, setHover] = useState<boolean | undefined>(undefined);
  return (
    <a
      href={href}
      target={target}
      rel={rel}
      style={{
        color: dark ? purple[500] : "white",
        fontWeight: 500,
        textDecoration: "none",
        borderBottom: isOnlyText
          ? dark
            ? "2px solid " + purple[500]
            : "2px solid white"
          : undefined,
        background: isOnlyText
          ? dark
            ? hover && href
              ? "rgba(41,40,129,0.05)"
              : "rgba(41,40,129,0.14)"
            : hover && href
            ? "rgba(255,255,255,0.3)"
            : "rgba(255,255,255,0.2)"
          : undefined,
        transition: "background 0.2s",
        cursor: href ? "pointer" : "default",
        ...style,
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {children}
    </a>
  );
};

export default StyledLink;
